export default __webpack_public_path__ + "static/d1-760adcc6f355603e2156e0cf8da3c8de.jpg";